export enum BarcodeTypes {
  location = 'LC',
  stockItem = 'SI',
  piece = 'PC',
  job = 'JB',
  machine = 'MC',
  operator = 'OP',
  warehouseAllocation = 'WA',
}
